import { structureModule } from '../../redux';
import { Structure } from '../../models';
import { WithDatasFetchingListening } from '../../hocs';

const enhancer = WithDatasFetchingListening<Structure>(structureModule.storeName);
export default enhancer;
